import React, { Children } from "react";
import styles from "./slide-container.module.css";

interface SlideContainerProps {
    index: number;
    children: React.ReactNode;
}

export function SlideContainer({ index, children }: SlideContainerProps): React.ReactElement {
    return (
        <div
            className={styles.slideContainer}
            style={{ transform: `translateX(${index * 100 * -1}%)` }}
        >
            {Children.map(children, (child, childIndex) => {
                const isVisible = childIndex === index;

                // we need to mark items as `inert` so that they are ignored by keyboard navigation
                // when offscreen/not active.
                // react 18 does not include this HTML property in its types, so we need to destructure it below
                const inertProps = (isVisible ? {} : { inert: "" }) as { inert?: string };

                return (
                    <div
                        className={styles.slide}
                        aria-hidden={!isVisible || undefined}
                        {...inertProps}
                    >
                        {child}
                    </div>
                );
            })}
        </div>
    );
}
